/**
 * Non-blocking "new lessons" notice: a downloaded content pack is waiting. Tapping swaps it in;
 * "Later" hides it (the pack is used on the next launch anyway).
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { applyPendingContent, dismissContentUpdate, useContentState } from '../lib/contentPack';
import { useT } from '../lib/i18n';
import { play } from '../lib/sfx';
import { Icon } from './icons';
import { toast } from './ui';

const FOCUSED = ['/lesson', '/onboarding', '/welcome', '/signin', '/paywall', '/studio/flow', '/s/', '/draw-together', '/unlock-all', '/whos-drawing'];

export function ContentUpdateNotice() {
  const t = useT();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const pending = useContentState((s) => s.pending);
  const downloaded = useContentState((s) => s.lastDownload);
  // Never interrupt a lesson, onboarding, a purchase or a capture flow: wait for the main tabs.
  if (!pending || FOCUSED.some((p) => pathname.startsWith(p))) return null;
  return (
    <div className="content-notice" role="status" data-testid="content-update" data-version={pending.version} data-download={downloaded.join(',')}>
      <Icon name="sparkle" size={20} />
      <b>{pending.lessons > 1 ? t('cu.titleN', { n: pending.lessons }) : pending.lessons === 1 ? t('cu.titleOne') : t('cu.title')}</b>
      <button
        type="button"
        className="btn btn-primary btn-small"
        data-testid="content-update-apply"
        onClick={() => {
          play('sparkle');
          void applyPendingContent();
          toast(t('cu.updated'));
          nav('/playground');
        }}
      >
        {t('cu.update')}
      </button>
      <button type="button" className="content-notice-later" data-testid="content-update-later" onClick={() => dismissContentUpdate()}>
        {t('cu.later')}
      </button>
    </div>
  );
}
